import type { Phrases } from '../common/Phrases.d';
import type { ButtonGroupOption } from '../../../components/react-hook-form/ButtonGroup';

import React, { useMemo } from 'react';
// import { ButtonGroup } from '../../../components/react-hook-form/ButtonGroup';
import { ButtonRadioGroup } from '/react4xp/components/react-hook-form/buttonRadioGroup/ButtonRadioGroup';
import {
	SERVICES_FIELD_NAME,
	FIELD_VALUE_ANALYZED,
	FIELD_VALUE_ANALYZED_HOW,
} from './constants';


export const AnalyzedHowButtonGroup = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const OPTIONS: ButtonGroupOption[] = useMemo(() => [{
		label: phrases['notificationForm.services.analyzedHowField.value.quickTest'],
		value: FIELD_VALUE_ANALYZED_HOW.QUICK_TEST,
	},{
		label: phrases['notificationForm.services.analyzedHowField.value.advanced'],
		value: FIELD_VALUE_ANALYZED_HOW.ADVANCED,
	},{
		label: phrases['notificationForm.services.analyzedHowField.value.other'],
		value: FIELD_VALUE_ANALYZED_HOW.OTHER,
	}], [phrases]);
	return (
		<ButtonRadioGroup
			className='z-0'
			description={phrases['notificationForm.term.chooseOne']}
			label={phrases['notificationForm.services.analyzedHowField.label']}
			name={SERVICES_FIELD_NAME.ANALYZED_HOW}
			options={OPTIONS}
			showIf={
				({watch}) => watch({ name: SERVICES_FIELD_NAME.ANALYZED }) === FIELD_VALUE_ANALYZED.YES
			}
		/>
	);
};
